import { harryMediaArray } from './harryMedia'
import { harryBio } from './harryBios'

import { hermioneReviewerReviewHinge, dumbledoreReviewerReviewBumble, ronReviewerReviewTinder } from './harryReviewerReviews'
import { hermioneReviewerProfile, dumbledoreReviewerProfile, ronReviewerProfile } from './harryReviewers'

export const hermioneProfileReviewHinge = {
  _id: 'hermioneProfileReviewHingeId',
  userId: 'harryUserId',
  userEmail: 'harry@email.com',
  datingProfileId: 'harryDatingProfileHingeId',
  reviewerProfileId: 'hermioneReviewerProfileId',
  reviewerEmail: 'hermione@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: harryMediaArray[4]._id,
      mediaItemURL: harryMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[4].type,
      caption: harryMediaArray[4].captions[2],
      subcaption: harryMediaArray[4].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[3]._id,
      mediaItemURL: harryMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[3].type,
      caption: harryMediaArray[3].captions[1],
      subcaption: harryMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[1]._id,
      mediaItemURL: harryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[1].type,
      caption: harryMediaArray[1].captions[2],
      subcaption: harryMediaArray[1].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[10]._id,
      mediaItemURL: harryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[10].type,
      caption: harryMediaArray[10].captions[0],
      subcaption: harryMediaArray[10].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[14]._id,
      mediaItemURL: harryMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[14].type,
      caption: harryMediaArray[14].captions[1],
      subcaption: harryMediaArray[14].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[15]._id,
      mediaItemURL: harryMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[15].type,
      caption: harryMediaArray[15].captions[0],
      subcaption: harryMediaArray[15].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look very intense here. Maybe something softer is better to start off with. You look good though.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `So studious lol... this is a good candid photo. You look well put together and confident`,
      verdict: 'Very',
    },
    {
      feedback: `Cool action shot! Again, very intense. Some of these vibes are duplicative. Still, it's a good photo`,
      verdict: 'Yes',
    },
    {
      feedback: `I like it because I know the backstory, but I think someone who doesn't know you might find it a bit strange`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Supermodel alert! Again, it's good, but you look intense in too many photos. Do you ever smile?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Finally a smile! Love the caption, and you look good!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: harryBio._id,
    vitalInfo: { ...harryBio.vitalInfo },
    prompts: [
      { ...harryBio.prompts[0] },
      { ...harryBio.prompts[1] },
      { ...harryBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `As if there are people who don't know who Harry Potter is`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, but it would be funnier if there was a photo of your lightning bolt scar`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Shows adventure, but it's not super humorous`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Again, shows adventure, but not very witty`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Harry is very handsome and well put together, but maybe a bit intense.`,
    good: `You're obviously super smart and well-oriented, and you manage to make yourself look handsome somehow too`,
    notGood: `The intensity. Try a few more pictures where you're smiling and some wittier prompt responses.`,
    verdict: `Overall the positives outweigh the negatives, but you're not yet showing your most attractive self. Adding a few more smiling photos and wittier prompt responses could really lighten your vibe and take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...hermioneReviewerReviewHinge },
  reviewerProfile: { ...hermioneReviewerProfile },
  bioItems: { ...harryBio },
  mediaItems: [ ...harryMediaArray ],
}

export const dumbledoreProfileReviewBumble = {
  _id: 'dumbledoreProfileReviewBumbleId',
  userId: 'harryUserId',
  userEmail: 'harry@email.com',
  datingProfileId: 'harryDatingProfileBumbleId',
  reviewerProfileId: 'dumbledoreReviewerProfileId',
  reviewerEmail: 'dumbledore@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: harryMediaArray[4]._id,
      mediaItemURL: harryMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[4].type,
      caption: harryMediaArray[4].captions[2],
      subcaption: harryMediaArray[4].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[3]._id,
      mediaItemURL: harryMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[3].type,
      caption: harryMediaArray[3].captions[1],
      subcaption: harryMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[1]._id,
      mediaItemURL: harryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[1].type,
      caption: harryMediaArray[1].captions[2],
      subcaption: harryMediaArray[1].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[10]._id,
      mediaItemURL: harryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[10].type,
      caption: harryMediaArray[10].captions[0],
      subcaption: harryMediaArray[10].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[14]._id,
      mediaItemURL: harryMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[14].type,
      caption: harryMediaArray[14].captions[1],
      subcaption: harryMediaArray[14].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[15]._id,
      mediaItemURL: harryMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[15].type,
      caption: harryMediaArray[15].captions[0],
      subcaption: harryMediaArray[15].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look very intense here. Maybe something softer is better to start off with. You look good though.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `So studious lol... this is a good candid photo. You look well put together and confident`,
      verdict: 'Very',
    },
    {
      feedback: `Cool action shot! Again, very intense. Some of these vibes are duplicative. Still, it's a good photo`,
      verdict: 'Yes',
    },
    {
      feedback: `I like it because I know the backstory, but I think someone who doesn't know you might find it a bit strange`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Supermodel alert! Again, it's good, but you look intense in too many photos. Do you ever smile?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Finally a smile! Love the caption, and you look good!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: harryBio._id,
    vitalInfo: { ...harryBio.vitalInfo },
    prompts: [
      { ...harryBio.prompts[0] },
      { ...harryBio.prompts[1] },
      { ...harryBio.prompts[2] }
    ],
    aboutMe: harryBio.aboutMe[0],
    hobbies: [harryBio.hobbies[0], harryBio.hobbies[1], harryBio.hobbies[2], harryBio.hobbies[3], harryBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `As if there are people who don't know who Harry Potter is`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'I laughed. Finally something funny',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, but it would be funnier if there was a photo of your lightning bolt scar`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Shows adventure, but it's not super humorous`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Again, shows adventure, but not very witty`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Harry is very handsome and well put together, but maybe a bit intense.`,
    good: `You're obviously super smart and well-oriented, and you manage to make yourself look handsome somehow too`,
    notGood: `The intensity. Try a few more pictures where you're smiling and some wittier prompt responses.`,
    verdict: `Overall the positives outweigh the negatives, but you're not yet showing your most attractive self. Adding a few more smiling photos and wittier prompt responses could really lighten your vibe and take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...dumbledoreReviewerReviewBumble },
  reviewerProfile: { ...dumbledoreReviewerProfile },
  bioItems: { ...harryBio },
  mediaItems: [ ...harryMediaArray ],
}

export const ronProfileReviewTinder = {
  _id: 'ronProfileReviewTinderId',
  userId: 'harryUserId',
  userEmail: 'harry@email.com',
  datingProfileId: 'harryDatingProfileTinderId',
  reviewerProfileId: 'ronReviewerProfileId',
  reviewerEmail: 'ron@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: harryMediaArray[4]._id,
      mediaItemURL: harryMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[4].type,
      caption: harryMediaArray[4].captions[2],
      subcaption: harryMediaArray[4].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[3]._id,
      mediaItemURL: harryMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[3].type,
      caption: harryMediaArray[3].captions[1],
      subcaption: harryMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[1]._id,
      mediaItemURL: harryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[1].type,
      caption: harryMediaArray[1].captions[2],
      subcaption: harryMediaArray[1].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[10]._id,
      mediaItemURL: harryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[10].type,
      caption: harryMediaArray[10].captions[0],
      subcaption: harryMediaArray[10].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[14]._id,
      mediaItemURL: harryMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[14].type,
      caption: harryMediaArray[14].captions[1],
      subcaption: harryMediaArray[14].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[15]._id,
      mediaItemURL: harryMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[15].type,
      caption: harryMediaArray[15].captions[0],
      subcaption: harryMediaArray[15].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look very intense here. Maybe something softer is better to start off with. You look good though.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `So studious lol... this is a good candid photo. You look well put together and confident`,
      verdict: 'Very',
    },
    {
      feedback: `Cool action shot! Again, very intense. Some of these vibes are duplicative. Still, it's a good photo`,
      verdict: 'Yes',
    },
    {
      feedback: `I like it because I know the backstory, but I think someone who doesn't know you might find it a bit strange`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Supermodel alert! Again, it's good, but you look intense in too many photos. Do you ever smile?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Finally a smile! Love the caption, and you look good!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: harryBio._id,
    vitalInfo: { ...harryBio.vitalInfo },
    prompts: [
      { ...harryBio.prompts[0] },
      { ...harryBio.prompts[1] },
      { ...harryBio.prompts[2] }
    ],
    aboutMe: harryBio.aboutMe[0],
    hobbies: [harryBio.hobbies[0], harryBio.hobbies[1], harryBio.hobbies[2], harryBio.hobbies[3], harryBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `As if there are people who don't know who Harry Potter is`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'I laughed. Finally something funny',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, but it would be funnier if there was a photo of your lightning bolt scar`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Shows adventure, but it's not super humorous`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Again, shows adventure, but not very witty`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Harry is very handsome and well put together, but maybe a bit intense.`,
    good: `You're obviously super smart and well-oriented, and you manage to make yourself look handsome somehow too`,
    notGood: `The intensity. Try a few more pictures where you're smiling and some wittier prompt responses.`,
    verdict: `Overall the positives outweigh the negatives, but you're not yet showing your most attractive self. Adding a few more smiling photos and wittier prompt responses could really lighten your vibe and take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...ronReviewerReviewTinder },
  reviewerProfile: { ...ronReviewerProfile },
  bioItems: { ...harryBio },
  mediaItems: [ ...harryMediaArray ],
}